import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner";

// services
import {
  useUpdateModuleStatusMutation,
  useBookmarkModuleMutation,
} from "../../store/services/moduleServerApi";

const Module_5_1_1 = () => {
  const navigate = useNavigate();
  const [
    updateModuleStatus,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { message: successMessage } = {},
    },
  ] = useUpdateModuleStatusMutation();
  if (successMessage) navigate("/overview");

  const handleCompleteTraining = () => {
    updateModuleStatus({ moduleNo: 5, end: 1 });
  };

  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">5.1.1 Module Summary</h1>
            <p className="mt-3">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12">
              <h2 className="b text-uppercase mb-3">
                <span className="orange">Congratulations!</span> You have
                completed the Amyvid Reporting Module.
              </h2>
              <p>
                Please click the button below to mark your training complete.
              </p>
            </div>
          </section>
          <LdsButton
            classes="blue-button mt-3 mb-5"
            disabled={isLoading}
            onClick={handleCompleteTraining}
          >
            Mark Complete
          </LdsButton>
        </main>
      </div>
    </div>
  );
};

export default Module_5_1_1;
